<template>
<div class="container-fluid bg-white">
	<toolbar>
		<h2><i class="fa fa-project-diagram"></i> Contacts Apps</h2>

		<div class="controls">
			<nav-tabs :tabs="[
					{
						icon: 'fa-project-diagram',
						label: 'Contacts',
						path: '/contacts'
					},
					{
						icon: 'fa-tractor',
						label: 'All Assets',
						path: '/contact-assets'
					}
				]"
				addon-apps-location="Contacts Module"
				addon-apps-link="/contacts/apps">
			</nav-tabs>
		</div>
	</toolbar>

	<addon-app-tab ui-location="Contacts Module"></addon-app-tab>
</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"
import AddonAppTab from "@/components/AddonAppTab"

export default {
	name: "ContactsApps",
	components: {
		Toolbar,
		NavTabs,
		AddonAppTab
	}
}
</script>
